(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-slideshow"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    /*
      Swiper is now self-hosted as theme assets (added via
      Online Store > Themes > Edit code > Assets):
        - swiper-bundle.min.js
        - swiper-bundle.min.css

      Their fingerprinted asset_url is rendered into data-swiper-js /
      data-swiper-css attributes on the outer <section> element (see the
      Liquid markup above), since {{ ... | asset_url }} cannot be evaluated
      inside this static {% javascript %} block. We read those attributes
      at runtime instead of pointing at a third-party CDN.
    */

    function loadSwiper(jsUrl, cssUrl) {
      if (window.__csSwiperPromise) return window.__csSwiperPromise;
      window.__csSwiperPromise = new Promise((resolve, reject) => {
        if (window.Swiper) { resolve(window.Swiper); return; }
        if (!cssUrl || !jsUrl) {
          reject(new Error('Swiper asset URLs missing on section element'));
          return;
        }
        if (!document.querySelector('link[data-cs-swiper-css]')) {
          const link = document.createElement('link');
          link.rel  = 'stylesheet';
          link.href = cssUrl;
          link.setAttribute('data-cs-swiper-css', '');
          document.head.appendChild(link);
        }
        const script    = document.createElement('script');
        script.src      = jsUrl;
        script.async    = true;
        script.onload   = () => resolve(window.Swiper);
        script.onerror  = () => reject(new Error('Failed to load Swiper'));
        document.head.appendChild(script);
      });
      return window.__csSwiperPromise;
    }

    function initSection(section) {
      if (section.dataset.csInitialized === 'true') return;
      section.dataset.csInitialized = 'true';

      const autoplayEnabled  = section.dataset.autoplay === 'true';
      const defaultDuration  = parseInt(section.dataset.slideDuration, 10) || 5000;
      const loop             = section.dataset.loop === 'true';
      const isNaturalHeight  = section.classList.contains('custom-slideshow--natural');

      const swiperEl = section.querySelector('.swiper');
      if (!swiperEl) return;

      const slides   = swiperEl.querySelectorAll('.swiper-slide');
      if (slides.length === 0) return;

      const arrowPrev = section.querySelector('.custom-slideshow__arrow--prev');
      const arrowNext = section.querySelector('.custom-slideshow__arrow--next');
      const pagiEl    = section.querySelector('.custom-slideshow__pagination');

      const swiperConfig = {
        loop: loop && slides.length > 1,
        speed: 600,
        autoHeight: isNaturalHeight,
        watchSlidesProgress: true,
        keyboard: { enabled: true },
        a11y: {
          prevSlideMessage: 'Previous slide',
          nextSlideMessage: 'Next slide'
        },
        on: {
          init:                      function () { handleSlideChange(this); },
          slideChangeTransitionEnd:  function () { handleSlideChange(this); }
        }
      };

      if (autoplayEnabled && slides.length > 1) {
        swiperConfig.autoplay = {
          delay: defaultDuration,
          disableOnInteraction: false,
          pauseOnMouseEnter: false
        };
      }

      if (arrowPrev && arrowNext) {
        swiperConfig.navigation = { prevEl: arrowPrev, nextEl: arrowNext };
      }

      if (pagiEl) {
        swiperConfig.pagination = { el: pagiEl, clickable: true };
      }

      const swiper = new window.Swiper(swiperEl, swiperConfig);

      function handleSlideChange(swiperInstance) {
        const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
        if (!activeSlide || !autoplayEnabled || !swiperInstance.autoplay) return;
        const customDur = parseInt(activeSlide.dataset.slideDuration, 10);
        const useDur    = customDur > 0 ? customDur : defaultDuration;
        swiperInstance.params.autoplay.delay = useDur;
        swiperInstance.autoplay.stop();
        swiperInstance.autoplay.start();
      }

      if ('IntersectionObserver' in window && autoplayEnabled) {
        const io = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!swiper.autoplay) return;
              if (entry.isIntersecting) {
                swiper.autoplay.start();
              } else {
                swiper.autoplay.stop();
              }
            });
          },
          { threshold: 0.1 }
        );
        io.observe(section);
      }

      if (isNaturalHeight) {
        swiperEl.querySelectorAll('img').forEach((img) => {
          if (img.complete) return;
          img.addEventListener('load', () => {
            if (swiper && typeof swiper.updateAutoHeight === 'function') {
              swiper.updateAutoHeight(0);
            }
          }, { once: true });
        });
      }
    }

    function initAll() {
      const sections = document.querySelectorAll('.custom-slideshow');
      if (sections.length === 0) return;

      if ('IntersectionObserver' in window) {
        const lazyIO = new IntersectionObserver((entries, obs) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              obs.unobserve(entry.target);
              const section = entry.target;
              loadSwiper(section.dataset.swiperJs, section.dataset.swiperCss)
                .then(() => initSection(section))
                .catch(console.error);
            }
          });
        }, { rootMargin: '200px 0px' });

        sections.forEach((s) => lazyIO.observe(s));
      } else {
        sections.forEach((section) => {
          loadSwiper(section.dataset.swiperJs, section.dataset.swiperCss)
            .then(() => initSection(section))
            .catch(console.error);
        });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', (e) => {
        const section = e.target.querySelector('.custom-slideshow');
        if (section) {
          loadSwiper(section.dataset.swiperJs, section.dataset.swiperCss)
            .then(() => initSection(section))
            .catch(console.error);
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;
      this.isAtTop = false;

      this.suppressScrollUntil = 0;
      this.toggleBtn = this.querySelector('header-menu-toggle');
      this.toggleBtn?.addEventListener('click', () => {
        this.suppressScrollUntil = performance.now() + 250;
        this.header.classList.toggle('shopify-section-header-menu-open');
      });

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.disconnectedCallback?.();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (performance.now() < this.suppressScrollUntil) {
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop <= 0) {
        this.header.classList.remove('shopify-section-header-sticky');
        document.body.classList.remove('shopify-body-section-header-sticky');
        this.isAtTop = true;
        this.currentScrollTop = scrollTop;
        return;
      }
      if (this.isAtTop && scrollTop > 10) {
        this.isAtTop = false;
      }
      if (this.isAtTop) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
